export default __webpack_public_path__ + "static/media/ext.77ed2dfa.JPG";